  (function(){
    var drawer = document.querySelector('[data-wubs-qad]:not([data-wubs-qad-initialized])');
    if(!drawer) return;
    drawer.setAttribute('data-wubs-qad-initialized', 'true');
    var sid = drawer.getAttribute('data-wubs-qad-sid') || 'wubs';

    window.__wubsQuickAddInit = window.__wubsQuickAddInit || {};
    if(window.__wubsQuickAddInit[sid]) return;
    window.__wubsQuickAddInit[sid] = true;

    var closeEls = drawer.querySelectorAll('[data-wubs-qad-close]');
    var imgEl = drawer.querySelector('[data-wubs-qad-img]');
    var navBtns = drawer.querySelectorAll('[data-wubs-qad-nav]');
    var titleEl = drawer.querySelector('[data-wubs-qad-title]');
    var priceEl = drawer.querySelector('[data-wubs-qad-price]');
    var compareEl = drawer.querySelector('[data-wubs-qad-compare]');
    var optWrap = drawer.querySelector('[data-wubs-qad-options]');
    var addBtn = drawer.querySelector('[data-wubs-qad-add]');
    var linkEl = drawer.querySelector('[data-wubs-qad-link]');
    var loadingEl = drawer.querySelector('[data-wubs-qad-loading]');
    var selectSizeLabel = drawer.getAttribute('data-select-size-label') || '';

    var state = {
      product: null,
      handle: '',
      url: '',
      images: [],
      imgIndex: 0,
      selected: [],
      variant: null
    };

    function rootPath(){
      try{
        if(window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
      }catch(e){}
      return '/';
    }

    function money(cents){
      try{
        if(window.Shopify && typeof window.Shopify.formatMoney === 'function'){
          var fmt = (window.theme && (window.theme.moneyFormat || window.theme.money_format)) || window.Shopify.money_format || drawer.getAttribute('data-money-format') || '\u007b\u007bamount\u007d\u007d kr';
          return window.Shopify.formatMoney(cents, fmt);
        }
      }catch(e){}
      var val = (Number(cents) || 0) / 100;
      try{
        return new Intl.NumberFormat('sv-SE', { style:'currency', currency: drawer.getAttribute('data-currency') || 'SEK' }).format(val);
      }catch(e){
        return (Math.round(val * 100) / 100).toFixed(2);
      }
    }

    function open(){
      drawer.hidden = false;
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          drawer.classList.add('is-open');
        });
      });
    }

    function close(){
      drawer.classList.remove('is-open');
      window.setTimeout(function(){
        if(!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 560);
    }

    function setLoading(on){
      if(loadingEl) loadingEl.hidden = !on;
      if(addBtn) addBtn.disabled = true;
    }

    function isColorName(name){
      var n = String(name || '').toLowerCase();
      return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 || n.indexOf('färg') !== -1 || n.indexOf('farg') !== -1;
    }
    function isSizeName(name){
      var n = String(name || '').toLowerCase();
      return n.indexOf('size') !== -1 || n.indexOf('storlek') !== -1;
    }

    function setImage(idx){
      if(!state.images.length || !imgEl) return;
      var max = state.images.length;
      var i = idx % max; if(i < 0) i = max - 1;
      state.imgIndex = i;
      imgEl.src = state.images[i];
    }

    function findVariantBySelected(){
      var p = state.product;
      if(!p || !p.variants) return null;

      var sel = state.selected;
      for(var i=0;i<p.variants.length;i++){
        var v = p.variants[i];
        var ok = true;
        if(sel[0] && v.option1 !== sel[0]) ok = false;
        if(sel[1] && v.option2 !== sel[1]) ok = false;
        if(sel[2] && v.option3 !== sel[2]) ok = false;
        if(ok) return v;
      }
      return null;
    }

    function anyAvailableFor(optionIndex, value){
      var p = state.product;
      if(!p || !p.variants) return false;

      var sel = state.selected.slice();
      sel[optionIndex] = value;

      for(var i=0;i<p.variants.length;i++){
        var v = p.variants[i];
        var ok = true;
        if(sel[0] && v.option1 !== sel[0]) ok = false;
        if(sel[1] && v.option2 !== sel[1]) ok = false;
        if(sel[2] && v.option3 !== sel[2]) ok = false;
        if(ok && v.available) return true;
      }
      return false;
    }

    function renderPrice(){
      var v = state.variant;
      if(!v || !priceEl) return;

      priceEl.textContent = money(v.price);

      var hasCompare = (typeof v.compare_at_price === 'number') && v.compare_at_price > v.price;
      if(compareEl){
        compareEl.hidden = !hasCompare;
        if(hasCompare) compareEl.textContent = money(v.compare_at_price);
      }
    }

    function renderOptions(){
      var p = state.product;
      if(!p || !optWrap) return;

      optWrap.innerHTML = '';

      var opts = p.options || [];
      function getOptName(o){
        if(typeof o === 'string') return o;
        if(o && typeof o.name === 'string') return o.name;
        return String(o || '');
      }

      for(var oi=0; oi<opts.length; oi++){
        var optName = getOptName(opts[oi]);

        var values = [];
        try{
          var map = {};
          for(var vi=0; vi<p.variants.length; vi++){
            var vv = p.variants[vi]['option' + (oi+1)];
            if(vv && !map[vv]){ map[vv] = 1; values.push(vv); }
          }
        }catch(e){}

        var selectedVal = state.selected[oi] || '';

        var optEl = document.createElement('div');
        optEl.className = 'wubs-qad__opt';
        optEl.setAttribute('data-opt-index', String(oi));

        var isColor = isColorName(optName);
        var isSize = isSizeName(optName);

        var label = document.createElement('div');
        label.className = 'wubs-qad__optLabel';

        var nameP = document.createElement('p');
        nameP.className = 'wubs-qad__optName';
        nameP.textContent = isColor ? (selectedVal || optName) : (isSize ? (selectSizeLabel || optName) : optName);

        var valP = document.createElement('p');
        valP.className = 'wubs-qad__optValue';
        valP.textContent = isColor ? '' : (selectedVal || '');

        label.appendChild(nameP);
        label.appendChild(valP);
        optEl.appendChild(label);

        var vals = document.createElement('div');
        vals.className = 'wubs-qad__vals';

        if(isColor) vals.classList.add('wubs-qad__vals--swatch');
        else if(isSize) vals.classList.add('wubs-qad__vals--size');

        for(var vi2=0; vi2<values.length; vi2++){
          var vval = values[vi2];
          var can = anyAvailableFor(oi, vval);

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('data-opt-val', vval);
          btn.setAttribute('aria-pressed', (vval === selectedVal) ? 'true' : 'false');
          btn.disabled = !can;

          if(isColor){
            btn.className = 'wubs-qad__swBtn';
            btn.setAttribute('aria-label', vval);

            var sw = document.createElement('span');
            sw.className = 'wubs-qad__sw';
            sw.style.background = String(vval || '').toLowerCase();
            btn.appendChild(sw);
          }else if(isSize){
            btn.className = 'wubs-qad__sizeBtn';
            btn.textContent = vval;
          }else{
            btn.className = 'wubs-qad__pillBtn';
            btn.textContent = vval;
          }

          vals.appendChild(btn);
        }

        optEl.appendChild(vals);
        optWrap.appendChild(optEl);
      }
    }

    function syncVariantAndUI(){
      state.variant = findVariantBySelected();

      if(titleEl && state.product) titleEl.textContent = state.product.title || '';
      if(linkEl){
        linkEl.href = state.url || (rootPath() + 'products/' + state.handle);
      }

      if(state.variant){
        renderPrice();
        if(addBtn) addBtn.disabled = !state.variant.available;
      }else{
        if(addBtn) addBtn.disabled = true;
      }

      renderOptions();
    }

    function pickInitialVariant(preferVariantId){
      var p = state.product;
      if(!p || !p.variants || !p.variants.length) return null;

      var v = null;

      if(preferVariantId){
        for(var i=0;i<p.variants.length;i++){
          if(Number(p.variants[i].id) === Number(preferVariantId)){
            v = p.variants[i];
            break;
          }
        }
      }

      if(!v){
        for(var j=0;j<p.variants.length;j++){
          if(p.variants[j].available){ v = p.variants[j]; break; }
        }
      }
      if(!v) v = p.variants[0];

      state.selected = [
        v.option1 || '',
        v.option2 || '',
        v.option3 || ''
      ];

      return v;
    }

    function fetchProduct(handle){
      var url = rootPath() + 'products/' + encodeURIComponent(handle) + '.js';
      return fetch(url, { credentials:'same-origin' })
        .then(function(r){
          if(!r.ok) throw new Error('product fetch failed');
          return r.json();
        });
    }

    function openFor(handle, opts){
      opts = opts || {};
      state.handle = String(handle || '');
      state.url = String(opts.url || '');
      state.product = null;
      state.images = [];
      state.imgIndex = 0;
      state.selected = [];
      state.variant = null;

      if(!state.handle){
        if(state.url) window.location.href = state.url;
        return;
      }

      open();
      var body = drawer.querySelector('.wubs-qad__body');
      if(body) body.scrollTop = 0;

      setLoading(true);

      fetchProduct(state.handle)
        .then(function(p){
          state.product = p;

          state.images = (p.images && p.images.length) ? p.images.slice(0) : [];
          if(!state.images.length && p.featured_image) state.images = [p.featured_image];

          state.variant = pickInitialVariant(opts.variantId);

          var firstImg = '';
          try{
            if(state.variant && state.variant.featured_image && state.variant.featured_image.src){
              firstImg = state.variant.featured_image.src;
            }
          }catch(e){}
          if(!firstImg) firstImg = state.images[0] || '';

          if(imgEl){
            imgEl.alt = (p.title || '');
            imgEl.src = firstImg;
          }

          if(firstImg && state.images.length){
            var idx = state.images.indexOf(firstImg);
            if(idx >= 0) state.imgIndex = idx;
          }

          setLoading(false);
          syncVariantAndUI();
        })
        .catch(function(){
          setLoading(false);
          close();
          window.location.href = state.url || (rootPath() + 'products/' + state.handle);
        });
    }

    function cartAdd(variantId){
      var url = rootPath() + 'cart/add.js';
      return fetch(url, {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        credentials:'same-origin',
        body: JSON.stringify({ items:[{ id: Number(variantId), quantity: 1 }] })
      }).then(function(r){
        if(!r.ok) return r.json().then(function(e){ throw e; });
        return r.json();
      });
    }

    for(var i=0;i<closeEls.length;i++){
      closeEls[i].addEventListener('click', function(){ close(); });
    }

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    drawer.addEventListener('click', function(e){
      var t = e.target;
      if(!t) return;

      var nav = t.closest && t.closest('[data-wubs-qad-nav]');
      if(nav){
        e.preventDefault();
        var dir = nav.getAttribute('data-wubs-qad-nav');
        if(dir === 'prev') setImage(state.imgIndex - 1);
        else setImage(state.imgIndex + 1);
        return;
      }

      var optBtn = t.closest && t.closest('[data-opt-val]');
      if(optBtn && optWrap && optWrap.contains(optBtn)){
        var optEl = optBtn.closest('[data-opt-index]');
        if(!optEl) return;

        var oi = Number(optEl.getAttribute('data-opt-index')) || 0;
        var val = optBtn.getAttribute('data-opt-val') || '';
        if(!val) return;

        state.selected[oi] = val;

        var v = findVariantBySelected();
        if(!v && state.product && state.product.variants){
          for(var k=0;k<state.product.variants.length;k++){
            var cand = state.product.variants[k];
            if(oi === 0 && cand.option1 !== val) continue;
            if(oi === 1 && cand.option2 !== val) continue;
            if(oi === 2 && cand.option3 !== val) continue;

            state.selected = [cand.option1 || '', cand.option2 || '', cand.option3 || ''];
            v = cand;
            break;
          }
        }
        state.variant = v;

        try{
          if(state.variant && state.variant.featured_image && state.variant.featured_image.src && imgEl){
            imgEl.src = state.variant.featured_image.src;
          }
        }catch(e){}

        syncVariantAndUI();
        return;
      }

      var add = t.closest && t.closest('[data-wubs-qad-add]');
      if(add){
        if(addBtn && addBtn.disabled) return;
        if(!state.variant) return;

        addBtn.disabled = true;
        cartAdd(state.variant.id)
          .then(function(){
            close();
            try{ document.dispatchEvent(new CustomEvent('wubs:cart-open')); }catch(e){}
          })
          .catch(function(){
            window.location.href = rootPath() + 'cart';
          })
          .finally(function(){
            addBtn.disabled = false;
          });
        return;
      }
    });

    document.addEventListener('wubs:quick-add-open', function(e){
      var d = (e && e.detail) ? e.detail : {};
      openFor(d.handle, { url: d.url, variantId: d.variantId });
    });

    window.wubsQuickAddOpen = window.wubsQuickAddOpen || {};
    window.wubsQuickAddOpen[sid] = function(handle, opts){ openFor(handle, opts || {}); };
  })();
